import DesignTokens from '@tableau/design-tokens';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

const cssPrefix = 'DeepLink';

const deepLinkHighlight = cssClass(cssPrefix, 'highlighted', {
    borderRadius: 2,
    border: '1px solid '+ applyColor(DesignTokens.color.link.inline.default.default, '#0B5CAB'),
    boxShadow: '0px 0px 4px 0px '+ applyColor(DesignTokens.color.link.inline.default.default, '#0B5CAB'),
    padding: 8,
    scrollMarginTop: 16,
    paddingLeft: 0,
    marginLeft: -1,
    marginBottom: 4,
    /*
        Remove the bottom padding from the last <td> element in the table.
        Used to remove spacing that makes the component off center when user settings are highlighted.
    */
    $nest: {
        '& tr:nth-last-child(1) td': {
            paddingBottom: '0px !important'
        }
    }
});

const deepLinkNoHighlight = cssClass(cssPrefix, 'unhighlighted', {
    border: 'none',
    boxShadow: 'none',
    scrollMarginTop: 16
});

export interface DeepLinkProps {
    readonly deepLinkId: string;
    readonly children: JSX.Element | JSX.Element[];
    readonly stylesOverrides?: React.CSSProperties;
}

export function DeepLink(props: DeepLinkProps) {
    const location = useLocation();
    const [highlight, setHighlight] = React.useState(false);

    React.useEffect(() => {
        if(FeatureFlags.beaconSearchEnabled){
            const queryParams: any = WindowLocationService.getHashQueryObject();
            if (Object.entries(queryParams).length !== 0 && queryParams.deeplink === props.deepLinkId) {
                setHighlight(true);
            } else {
                setHighlight(false);
            }
        }
    }, [location, props.deepLinkId]);

    return (
       FeatureFlags.beaconSearchEnabled ?
        <section
            data-deeplink-id={props.deepLinkId}
            className={highlight ? `${deepLinkHighlight}` : deepLinkNoHighlight}
            style={props.stylesOverrides}
        >
            {props.children}
        </section> :  <> {props.children} </>
    );
}
